var bannerSlider = new Swiper('.banner-slider_JS', {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
});


// WEBPACK FOOTER //
// ./resources/assets/js/slider-shipping.js